import styles from './styles.module.scss';

export const SectionTitle: React.FC<{ title: string }> = ({ title }) => (
  <h3 className={styles.sectionTitle}>{title}</h3>
);
